import {AsyncPriceCourseCardContext} from '@udemy/browse-course';
import {PAGE_TYPE_LOGGED_OUT_HOMEPAGE} from '@udemy/discovery-api';
import {useMatchMedia} from '@udemy/hooks';
import {
    CourseUnit,
    CourseUnitSkeletonVerticalLayout,
    DiscoveryUnitsContainer,
} from '@udemy/react-discovery-units';

export const DiscoveryUnits = () => {
    const isMobileMax = useMatchMedia('mobile-max');

    const stackedLayoutProps = {
        layout: 'singlecol' as const,
        showStackedProductCardLayout: true,
        disableInfiniteScroll: true,
        showAddToCartInCourseCard: true,
        addToCartButtonStyle: 'secondary' as const,
        addToCartButtonSize: 'xsmall' as const,
        courseCardProps: {
            layout: 'vertical',
            showCourseTag: false,
            showDescription: false,
            showDetails: false,
            showRibbonsLast: true,
            disablePremiumHighlightedRibbon: true,
        },
        showInstructorDetails: true,
        isMobileMax: isMobileMax ?? undefined,
        showQuickViewBox: false,
        maxCardsPerStack: 3,
        maxCards: 3,
        showDividers: false,
        loadingSkeleton: <CourseUnitSkeletonVerticalLayout />,
    };

    const getUnitComponentAndProps = () => {
        return {
            component: CourseUnit,
            componentProps: {
                showTitle: false,
                renderExperimentalCourseCards: false,
                layout: 'singlerow',
                titleTypography: 'ud-heading-serif-xxl ud-text-responsive',
                showPager: true,
                allowScroll: true,
                ...(!!isMobileMax && stackedLayoutProps),
            },
        };
    };

    return (
        <AsyncPriceCourseCardContext.Provider
            value={
                !!isMobileMax
                    ? {
                          useCourseProductCard: true,
                          hideCourseDescription: true,
                      }
                    : {}
            }
        >
            <DiscoveryUnitsContainer
                itemCount={18}
                pageType={PAGE_TYPE_LOGGED_OUT_HOMEPAGE}
                getUnitComponentAndProps={getUnitComponentAndProps}
            />
        </AsyncPriceCourseCardContext.Provider>
    );
};
